import {HttpStatusCode} from 'data/protocols/http';

export function throwIfAllSettledErrorsAreNot422<T>(results: PromiseSettledResult<T>[]): void {
	const allRejected = results.every(result => result.status === 'rejected');

	if (!allRejected) return;

	const all422Errors = results.every(
		result =>
			result.status === 'rejected' && result.reason?.status === HttpStatusCode.unprocessable,
	);

	if (!all422Errors) {
		throw new Error();
	}
}
